<template>
  <div id="maintenanceInclusionsAndExclusion">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Maintenance Inclusions And Exclusion</div>
          <div class="web-action-btn btn-groups text-right">
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'maintenanceInclusionsAndExclusion'" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'maintenanceInclusionsAndExclusion'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                      mode="remote"
                      ref="maintenanceInclusionsAndExclusionTable"
                      title="Maintenance Inclusions And Exclusion"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      @on-select-all="onSelectAll"
                      @on-selected-rows-change="selectionChanged"
                      :totalRows="totalRecords"
                      :columns="userColumns"
                      :rows="rows"
                      :paginationOptions="{
                          enabled: false,
                          position: 'both',
                          perPage: perPage,
                          dropdownAllowAll: false,
                          setCurrentPage:listCurrentPage,
                          perPageDropdown:dropDownPerPage,
                      }"
                      :select-options="{
                          enabled: false,
                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                          selectionInfoClass: 'custom-class',
                          selectionText: 'rows selected',
                          clearSelectionText: 'clear',
                      }"
                      :search-options="{
                      enabled: false,
                      }"

                >
                </vue-good-table>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
            <div class="bg-white text-center">
                <h1>
                    Oops!</h1>
                <h2>
                    403 </h2>
                <div class="error-details">
                    Sorry!, You don't have permission to access this page.
                </div>
            </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
  import Vue from "vue";
  
  
  
  
  
  import {commonMixins} from '../../mixins/commonMixins';
  import {dataTableMixins} from '../../mixins/dataTableMixins';
  export default {
    name: "MaintenanceInclusionsAndExclusion",
    metaInfo(){
        return {
          title : 'Maintenance Inclusions And Exclusion | FleetPro Application'
        }
      },
    mixins: [commonMixins,dataTableMixins],
    data: () => ({
      cantAccessPage:"",
      loading: false,
      action: '',
      permissions:[],
      rows: [],
      totalRecords: 0,
      userColumns:[],
      columns:[
          {
              label: 'Agreement Header Type',
              field: 'arg_header',
              filterable: false,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: 'Agreement Number',
              field: 'agr_number',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: 'Unit Number',
              field: 'unit_no',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: 'Equipment Type',
              field: 'equip_type',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: "Equipment Type Description",
              field: "equip_type_desc",
              filterable: true,
              fpFieldType:"custom_date",
              hidden:false,
          },
          {
              label: 'Unit Assign Date',
              field: 'unit_assign_date',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: 'Contract Type',
              field: 'contract_type',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: 'Section',
              field: 'section',
              hidden:false,
              fpFieldType:"custom_date",
              filterable: true
          },
          {
              label: 'Process Sequence',
              field: 'process_sequence',
              hidden:false,
              fpFieldType:"custom_date",
              filterable: true
          },
          {
              label: 'Include/ Exclude?',
              field: 'inc_or_exc',
              fpFieldType:"text",
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: 'Freq Qty Included',
              field: 'fre_que_included',
              fpFieldType:"option",
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: 'Qty Included',
              field: 'qty_inc',
              fpFieldType:"text",
              hidden:false,
              filterable: true,
              sortable: true,
          },
          {
              label: 'Qty Performed',
              field: 'qty_performed',
              fpFieldType:"integer",
              hidden:false,
              type:'number',
              filterable: false,
              sortable: false,
          },
          {
              label: 'Previous Qty Performed',
              field: 'pre_qty_performed',
              fpFieldType:"integer",
              hidden:false,
              type:'number',
              filterable: false,
              sortable: false,
          },
          {
              label: 'Pct Utilized in Period',
              field: 'pct_util_in_period',
              fpFieldType:"integer",
              hidden:false,
              type:'number',
              filterable: false,
              sortable: false,
          },
          {
              label: 'Date Maint Qty Perf As Of',
              field: 'days_util_qty',
              fpFieldType:"integer",
              hidden:false,
              type:'number',
              filterable: false,
              sortable: false,
          },
          {
              label: 'Contract To Date Qty',
              field: 'contract_qty',
              fpFieldType:"option",
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: 'Company Code',
              field: 'company_code',
              fpFieldType:"text",
              hidden:false,
              filterable: true,
              sortable: true,
          },
          {
              label: "Customer Number",
              field: "cust_number",
              filterable: true,
              fpFieldType:"text",
              hidden:false,
          },
          {
              label: "Customer Suffix",
              field: "cust_suffix",
              filterable: true,
              fpFieldType:"text",
              hidden:false,
          },
          {
              label: 'Customer Name',
              field: 'customer_name',
              fpFieldType:"text",
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: 'Metric Type',
              field: 'metric_type',
              fpFieldType:"text",
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: 'Metric Value',
              field: 'metric_value',
              fpFieldType:"text",
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: 'PM Program',
              field: 'pm_program',
              fpFieldType:"text",
              hidden:false,
              type:'number',
              filterable: false,
              sortable: false,
          },
          {
              label: 'Program Description',
              field: 'program_description',
              fpFieldType:"text",
              hidden:false,
              type:'number',
              filterable: false,
              sortable: false,
          },
          {
              label: 'Reason Code',
              field: 'reason_code',
              fpFieldType:"text",
              hidden:false,
              type:'number',
              filterable: false,
              sortable: false,
          },
          {
              label: 'Reason Description',
              field: 'reason_desc',
              fpFieldType:"text",
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: "Primary System Code",
              field: "pri_sysyem_code",
              filterable: false,
              fpFieldType:"text",
              hidden:true,
              sortable: false,
          },
          {
              label: "Subsystem Code",
              field: "subsystem_code",
              filterable: false,
              fpFieldType:"text",
              hidden:true,
              sortable: false,
          },
          {
              label: "Subsystem Component Code",
              field: "sub_comp_code",
              filterable: false,
              fpFieldType:"text",
              hidden:true,
              sortable: false,
          },
          {
              label: "Subsystem Component Desc",
              field: "sub_comp_desc",
              filterable: false,
              fpFieldType:"text",
              hidden:true,
              sortable: false,
          },
      ],
      batchProcess:0,
      batchNum:"",
    }),
    watch:{
      permissions: function(permission) {
          var self = this;
          permission.forEach(function (permissions) {
              if(permissions.name == 'maintenance_inclusions_and_exclusions_report') {
                  self.cantAccessPage = true;
              }
          });
          if(self.cantAccessPage == ''){
              self.cantAccessPage = false;
          }
      },
    },
    mounted: function(){
      var self = this;
      self.getPermissions();
    },
    methods:{
        cancelAll: function (cancelAll) {
            this.$refs.maintenanceInclusionsAndExclusionTable.unselectAllInternal();
        },
      loadList: function(){

        var self = this;
        self.loading = true;
        var date = new Date();
        var offset = date.getTimezoneOffset();
        
          $.ajax({
              url: process.env.ROOT_API + "/maintenance-inclusions-and-exclusions-report/list",
              type: "POST",
              crossDomain: true,
              headers: this.ajxHeaders,
              dataType: "json",
              data: {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: this.serverParams.columnFilters,
                sort: this.serverParams.sort,
                offset: offset,
                action:self.action,

              },
              success: function(data) {
                self.loading = false;
                //console.log(data.content[0]["id"]);
                  if (data.status == "success") {

                    if ( self.action == "export" ||  self.action == "export_queue") {

                        if ( data.code == "201" ) {
                            alert(data.message);
                        } else {

                            if ( self.action == "export" ) {

                                self.excel = data.content.web;
                                var save = document.createElement("a");
                                save.href = self.excel;
                                save.download = data.content.web;
                                save.target = "_blank";

                                document.body.appendChild(save);
                                save.click();
                                document.body.removeChild(save);

                            } else {

                                self.batchProcess = 1;
                                self.batchNum = data.content;
                            }

                        }

                        self.action = "list";
                        // self.loadList();
                        return;
                    } else {
                      if (data.content.row != undefined) {
                        self.rows = data.content.row;
                      }
                      self.totalRecords = data.content.totalRecords;
                    }
                  }
              },
              error: function(jqXHR, exception) {
                self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,true,'maintenance-inclusions-and-exclusion')
              }
            });


      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/reports/MaintenanceInclusionsAndExclusionsReport.vue